var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pdfjs-viewer-element',{ref:"pdfViewer",staticClass:"pdf-viewer",attrs:{"src":_vm.src,"viewer-path":"/pdfjs-4.4.168","viewer-extra-styles":"#openFile { display: none }","pagemode":"none","zoom":_vm.scale}})
}
var staticRenderFns = []

export { render, staticRenderFns }